export const getBaseStreamUrls = () => {
  return {
    VIDEO: process.env.REACT_APP_VIDEO_STREAM_URL || 'rtsp://reader:Smartlight123@164.52.201.205:8554/Cam-001/video',
    AUDIO: process.env.REACT_APP_AUDIO_STREAM_URL || 'rtsp://reader:Smartlight123@164.52.201.205:8554/Cam-001/audio',
    THERMAL: process.env.REACT_APP_THERMAL_STREAM_URL || 'rtsp://reader:Smartlight123@164.52.201.205:8554/Cam-001/thermal',
    PUBLISH_AUDIO: process.env.REACT_APP_PUBLISH_AUDIO_STREAM_URL || 'rtsp://publisher:Smartlight123@164.52.201.205:8554/Cam-001/app'
  };
};

export const RTSP_URLS = getBaseStreamUrls();

/**
 * Format any device input (e.g. 1, 5, '001', 'VC-002', 'Cam-005', 'Smartlight-005') to a 3-digit string like '001', '005'
 */
export const formatDeviceId = (deviceId) => {
  if (deviceId === undefined || deviceId === null || deviceId === '') return '001';
  const str = String(deviceId).trim();
  const digitsMatch = str.match(/\d+/);
  if (digitsMatch) {
    return String(digitsMatch[0]).padStart(3, '0');
  }
  return '001';
};

/**
 * Generate stream URL replacing Cam-XXX or Smartlight-XXX with {streamPrefix}-{formattedId}
 * @param {string} streamType - 'video' | 'thermal' | 'audio'
 * @param {string|number} deviceId - device ID e.g. 1, '001'
 * @param {string} prefix - 'Cam' | 'Smartlight' (defaults to 'Cam')
 */
export const getDeviceStreamUrl = (streamType, deviceId, prefix = 'Cam') => {
  const baseUrls = getBaseStreamUrls();
  const formattedId = formatDeviceId(deviceId);
  const typeKey = String(streamType || 'video').toUpperCase();
  const rawUrl = baseUrls[typeKey] || baseUrls.VIDEO;
  const cleanPrefix = (String(prefix).toLowerCase().includes('smartlight')) ? 'Smartlight' : 'Cam';

  if (/(Cam|Smartlight)-\d+/i.test(rawUrl)) {
    return rawUrl.replace(/(Cam|Smartlight)-\d+/gi, `${cleanPrefix}-${formattedId}`);
  }
  return rawUrl.replace(/\/\d+/g, `/${cleanPrefix}-${formattedId}`);
};

export const getDevicePublishAudioUrl = (deviceId, prefix = 'Cam') => {
  const baseUrls = getBaseStreamUrls();
  const formattedId = formatDeviceId(deviceId);
  const cleanPrefix = (String(prefix).toLowerCase().includes('smartlight')) ? 'Smartlight' : 'Cam';
  const rawUrl = baseUrls.PUBLISH_AUDIO;

  if (/(Cam|Smartlight)-\d+/i.test(rawUrl)) {
    return rawUrl.replace(/(Cam|Smartlight)-\d+/gi, `${cleanPrefix}-${formattedId}`);
  }
  return rawUrl.replace(/\/\d+/g, `/${cleanPrefix}-${formattedId}`);
};


export const getCameraStreamsForDevice = (deviceId, prefix = 'Cam') => {
  const formattedId = formatDeviceId(deviceId);
  const cleanPrefix = (String(prefix).toLowerCase().includes('smartlight')) ? 'Smartlight' : 'Cam';
  return [
    {
      id: 'video',
      label: 'Video',
      name: `Video Stream (${cleanPrefix}-${formattedId})`,
      url: getDeviceStreamUrl('video', deviceId, cleanPrefix)
    },
    {
      id: 'thermal',
      label: 'Thermal',
      name: `Thermal Stream (${cleanPrefix}-${formattedId})`,
      url: getDeviceStreamUrl('thermal', deviceId, cleanPrefix)
    },
    {
      id: 'audio',
      label: 'Audio',
      name: `Audio Stream (${cleanPrefix}-${formattedId})`,
      url: getDeviceStreamUrl('audio', deviceId, cleanPrefix)
    }
  ];
};

export const CAMERA_STREAMS = getCameraStreamsForDevice('001');

export default RTSP_URLS;
